import React from 'react';
//import ReactDOM from 'react-dom';
import RaisedButton from 'material-ui/RaisedButton';
import EditorStep1 from './EditorStep1';
import EditorStep2 from './EditorStep2';
import EditorStep3 from './EditorStep3';
import '../../css/components/CollectionEditor/content_editor.css';
import { browserHistory } from 'react-router';

var $ = require('jquery');
var request = require('superagent');
var env = require('../../utils/env');
// var ConceptRes = require('../../resources/concept');
var CollectionRes = require('../../resources/collection');
var apiDomain = env.domain.api;
import notification from '../Modal/notification';
import createNotificationDialog from '../Modal/createNotificationDialog';
import Helpers from '../../utils/helpers';
import ReactDOM from 'react-dom';

var retrieveCollection = function(collectionId, callback) {
  callback = callback || function(){};
  CollectionRes.retrieveSingleCollection({collectionId: collectionId}, function(err, res) {
    return callback(err, res)
  })
}

var CollectionEditor = React.createClass({
  conceptLeafMapping: {},
  conceptsMap: {},
  submitCollection: function() {
    var collection = this.state.collection;
    collection.status = 'to_be_reviewed';
    this.saveCollection(function(err, res) {
      if (err) {
        notification.open({
          message: 'Error',
          description: "Cannot submit collection for reviewing. Please try again"
        })
      } else {
        notification.open({
          message: 'Success',
          description: "Collection " + collection.title + " is successfully submitted"
        })
        browserHistory.push('/collections');
      }
    });
  },
  saveCollection: function(callback) {
    var _this = this;
    var collection = this.state.collection;
    var titleValidation = !!(collection.title && collection.title.trim());
    if (!titleValidation) {
      return this.refs["EditorStep1"].invalidTitleOnSave();
    }
    var longQValidation = this.validateLongQuestionData();
    if (!longQValidation.isValid) {
      collection.questions[longQValidation.invalidSumMarkQuestionIndex].kquestion.sumMarkError = true;
      this.dialogNotification = createNotificationDialog({
        title: 'Cannot Save',
        content: 'Question ' + (longQValidation.invalidSumMarkQuestionIndex+1) + ': sum of part\'s mark should be equal to question\'s mark'
      }, function() {
        _this.setState({
          collection: collection,
          openNotificationDialog: false
        });
      })
      this.setState({
        openNotificationDialog: true
      })
      return;
    }
    $("body, html").addClass("heavy-load");
    var updatedConcept = this.getChosenConcept();
    var subject = Helpers.getSubject(this.conceptsMap, updatedConcept._id);
    if (!collection.metadata) collection.metadata = {};
    collection.metadata.subjectName = subject.title;
    collection.metadata.conceptName = this.conceptLeafMapping[updatedConcept._id].title;
    collection.concepts = [updatedConcept._id];
    for (var i = 0; i < collection.questions.length; i++) {
      collection.questions[i].kquestion.concepts = [updatedConcept._id];
    }
    this.setTypeForTextInputAnswers();
    CollectionRes.saveCollection(collection, (err, res) => {
      $("body, html").removeClass("heavy-load");
      if (callback) return callback(err, res);
      if (err) {
        return notification.open({
          message: 'Error',
          description: 'Cannot save collection. Please try again'
        })
      }
      this.setState({
        collection: res
      }, () => {
        notification.open({
          message: 'Success',
          description: "Collection has been saved!"
        })
        if (_this.state.isCreateNew) browserHistory.push('/collections');
      })
    })
  },
  validateLongQuestionData: function(){
    var result = {
      isValid: true,
      invalidSumMarkQuestionIndex: -1
    }
    var collection = this.state.collection;
    console.log("--------------------Collection-------------")
    console.log("collection ",collection)
    for (var i = 0; i < collection.questions.length; i++) {
      if (collection.questions[i].kquestion.type !== 22) continue;
      var kquestion = collection.questions[i].kquestion;
      var sum = 0, questionMark = kquestion.score;
      for (var j = 0; j < kquestion.textInputAnswers.length; j++) {
        sum += kquestion.textInputAnswers[j].answerValue;
      }

      // if total points of each part does not equal point of this long question, return invalid
      if (sum !== questionMark) { 
        result.isValid = false;
        result.invalidSumMarkQuestionIndex = i;
      }
    }
    return result;
  },
  setTypeForTextInputAnswers: function() {
    var collection = this.state.collection;
    for (var i = 0; i < collection.questions.length; i++) {

      var kquestion = collection.questions[i].kquestion;
      if (kquestion.type === 11) continue;

      for (var j = 0; j < kquestion.textInputAnswers.length; j++) {

        if (kquestion.type === 21 || (kquestion.textInputAnswers[j].text && kquestion.textInputAnswers[j].type !== 'AUTO_MARKING' && kquestion.textInputAnswers[j].type !== 'MANUAL_MARKING') || kquestion.textInputAnswers[j].type === "AUTO_MARKING") {
          kquestion.textInputAnswers[j].type = "AUTO_MARKING";
        } else {
          kquestion.textInputAnswers[j].type = "MANUAL_MARKING";
        }

      }
    }
  },
  navigateStep: function(step) {
    // Enable changing step from clicking 3 labels
    // return;
    // if (this.state.currentStepIndex !== this.steps.indexOf(step)) {
    //   this.setState({
    //     currentStepIndex: this.steps.indexOf(step)
    //   });
    // }
    if (this.state.currentStepIndex !== this.steps.indexOf(step)) {
      var stepInstance = null;
      if (this.state.currentStepIndex === 0) stepInstance = this.refs["EditorStep1"];
      else if (this.state.currentStepIndex === 1) stepInstance = this.refs["EditorStep2"];
      if (!stepInstance) return this.setState({currentStepIndex: this.steps.indexOf(step)});
      var validation = stepInstance.validateBeforNavigating();
      if (validation.isValid) return this.setState({currentStepIndex: this.steps.indexOf(step)});
    }
  },
  stepChangeHandle: function(value) {
    this.setState({
      currentStepIndex: value
    })
  },
  getChosenConcept: function(conceptObj) {
    if (!conceptObj) return this.getChosenConcept(this.state.concepts);
    else {
      if (conceptObj.activeChildren) return this.getChosenConcept(conceptObj.activeChildren);
      else return conceptObj;
    }
  },
  removeQuestion: function(question) {
    console.log(question);
    var _this = this;
    var questions = this.state.collection.questions;
    questions.splice(questions.indexOf(question), 1);
    if (question.kquestion._id) {
      request.delete(apiDomain + '/v1/kquizzes/' + this.props.params.collectionId + '/kquestions/' + question.kquestion._id)
      .withCredentials()
      .then(function(response) {
        // _this.setState(_state);
      }, function(err) {
        // Handle err case here
      })
    }
    this.setState({collection: this.state.collection});
  },
  updateConceptChange: function(concept) {
    this.newUpdatedConcept = this.getChosenConcept(concept);
    this.bindConceptToQuestion(this.newUpdatedConcept);
  },
  bindConceptToQuestion: function(newConcept) {
    var collection = this.state.collection;
    for (var i = 0; i < collection.questions.length; i++) {
      var kquestion = collection.questions[i].kquestion;
      kquestion.concepts = [newConcept._id];
    }
    this.setState({
      collection: collection
    })
  },
  updateConceptLeafMapping: function(result) {
    this.conceptLeafMapping = result;
  },
  updateConceptsMap: function(result) {
    this.conceptsMap = result;
  },
  updateConcepts: function(concepts) {
    this.setState({
      concepts: concepts
    })
  },
  updateSubject: function(subject) {
    this.setState({
      subject: subject
    })
    console.log('-------------------Change subject------------', subject)
    if(subject !== 'a234e6f6-a3ee-4bfe-9143-5c52f89ac84c'){
      var collection = this.state.collection;
      console.log("--------------------Collection-------------")
      for (var i = 0; i < collection.questions.length; i++) {
        if (collection.questions[i].kquestion.type !== 22) continue;
        var kquestion = collection.questions[i].kquestion;
        for (var j = 0; j < collection.questions[i].kquestion.textInputAnswers.length; j++) {
          delete collection.questions[i].kquestion.textInputAnswers[j].preText;
          delete collection.questions[i].kquestion.textInputAnswers[j].postText;
          collection.questions[i].kquestion.textInputAnswers[j].text = '';
          collection.questions[i].kquestion.textInputAnswers[j].type = 'MANUAL_MARKING';
        }
        this.setState({
          collection
        })
      }
    }
    
  },
  changeCollectionStatus: function(status) {
    var _this = this;
    request.put(apiDomain + "/v1/kquizzes/" + this.props.params.collectionId)
    .send({status: status})
    .withCredentials()
    .then(function(response) {
      _this.state.collection.status = status;
      notification.open({
        message: 'Success',
        description: 'Collection has been updated!'
      })
      _this.setState({collection: _this.state.collection})
    }, function(err) {
      notification.open({
        message: 'Error',
        description: 'Cannot update collection. Please try again later!'
      })
    })
  },
  renderEditorComp: function() {
    var editorStep;
    var tabClassname = "tab-active-" + this.state.currentStepIndex;
    editorStep = (
      <div className={"tab " + tabClassname}>
        <div className="tab-pane">
          <EditorStep1
            collection={this.state.collection}
            onSubjectChange={this.updateSubject}
            onConceptChange={this.updateConceptChange}
            onStepChange={this.stepChangeHandle}
            updateConceptLeafMapping={this.updateConceptLeafMapping}
            updateConceptsMap={this.updateConceptsMap}
            updateConcepts={this.updateConcepts}
            ref="EditorStep1"/>
        </div>
        <div className="tab-pane">
          <EditorStep2
            questions={this.state.collection.questions}
            subject={this.state.subject}
            onStepChange={this.stepChangeHandle}
            onQuestionRemove={this.removeQuestion}
            changeCollectionStatus={this.changeCollectionStatus}
            ref="EditorStep2"/>
        </div>
        <div className="tab-pane">
          <EditorStep3
            conceptLeaf={this.conceptLeafMapping}
            questions={this.state.collection.questions}
            onStepChange={this.stepChangeHandle}
            submitCollection={this.submitCollection}/>
        </div>
      </div>
    )
    return editorStep;
  },
  getInitialState: function() {
    var _this = this;
    var initialState = {
      isCreateNew: this.props.params.collectionId && this.props.params.collectionId.toLowerCase() === 'new',
      collection: {
        concepts: [],
        status: "self"
      },
      subject: "a234e6f6-a3ee-4bfe-9143-5c52f89ac84c"
    };
    initialState.currentStepIndex = initialState.isCreateNew ? 0 : 1;
    initialState.collection.questions = initialState.isCreateNew ? (
      [{
        kquestion: {
          type: 11,
          diffLevel: .25,
          score: 1,
          description: "",
          image: "",
          concepts: [],
          solution: [],
          metadata: {},
          textInputAnswers: [],
          selectionChoices: [{
            text: "",
            image: "",
            answerValue: 1
          }, {
            text: "",
            image: "",
            answerValue: 0
          }, {
            text: "",
            image: "",
            answerValue: 0
          }, {
            text: "",
            image: "",
            answerValue: 0
          }]
        }
      }]
    ) : [];
    return initialState;
  },
  componentWillMount: function() {
    this.steps = [{
      title: "Select Concept"
    }, {
      title: "Add Questions"
    }, {
      title: "Preview & Submit"
    }];
  },
  componentWillReceiveProps: function(nextProps) {
  },
  render: function() {
    var _this = this;
    return (
      <div className="editor">
        <div className="content-toolbar">
          <h3>New Collection</h3>
          <div className="btn-holder">
            <RaisedButton
              onClick={this.saveCollection.bind(_this, null)}
              target="_blank"
              label="Save as Draft"
              primary={true}
              icon={<i style={{"color": "white"}} className="fa fa-save" />}
            />
          </div>
        </div>
        <div className="content-step">
          {
            _this.steps.map((step, index)=>{
              return (
                <div className={"step " + (_this.state.currentStepIndex === index ? 'active':'')} key={index} onClick={_this.navigateStep.bind(_this, step)}>{step.title}</div>
              )
            })
          }
        </div>
        {this.renderEditorComp()}
        {this.state.openNotificationDialog && this.dialogNotification}
    
      </div>
    )
  },
  componentDidMount: function() {
    // Data flow
    var _this = this;
    // var collection = _this.state.collection;
    _this.bindConceptToQuestion({});
    if (_this.props.params.collectionId && _this.props.params.collectionId.toLowerCase() !== 'new') {
      retrieveCollection(_this.props.params.collectionId, function(err, res) {
        if(!err && res) _this.setState({collection: res})
      });
    }
  },
  componentDidUpdate: function(prevProps) {
    window.onbeforeunload = function() {
      return '';
    }
    var _this = this;
    var oldId = prevProps.params.collectionId,
        newId = this.props.params.collectionId;
    if (oldId !== newId && newId.toLowerCase() !== 'new') {
      console.log('should update component');
      retrieveCollection(newId, function(err, res) {
        if (!err && res) _this.setState({collection: res});
      })
    }
    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, ReactDOM.findDOMNode(_this)]);
  },
  componentWillUnmount: function() {
    window.onbeforeunload = function() {
      return undefined;
    }
  },
})

export default CollectionEditor;



/** WEBPACK FOOTER **
 ** ./src/components/CollectionEditor/CollectionEditor.js
 **/